import { DialogTitle } from '@mui/material';
import { BaseDialogTitleProps } from './BaseDialogTitle.types';

/**
 * BaseDialogTitle component that wraps the MUI DialogTitle component.
 *
 * @param id - The ID for the dialog element to point to for the title.
 * @param ariaLabel - The aria-label attribute for the dialog title for accessibility.
 * @param className - The className attribute to apply custom styles to the dialog title.
 * @param children - Elements to be displayed within the dialog title.
 */
export const BaseDialogTitle = ({
    id,
    ariaLabel,
    className,
    children,
}: BaseDialogTitleProps) => {
    return (
        <DialogTitle
            id={id}
            aria-label={ariaLabel}
            className={className}
        >
            {children}
        </DialogTitle>
    );
};